var MDB = window.MDB || {};
MDB.DPN = MDB.DPN || {};
MDB.DPN.BriggsAndWalker = MDB.DPN.BriggsAndWalker || {};

(function () {
    var _backButton
        , _container
        , _containerRow
        , _formMethod;
    
    $.extend(MDB.DPN.BriggsAndWalker, {
        _enableBackButton: function(){
            _backButton.show();
        },
        _disableBackButton: function(){
            _backButton.hide();
        },
        _scalePdfContainer: function (pdf) {
            var navbarHeight = $('.navbar-static-top').height();
            var clientHeight = document.documentElement.clientHeight;

            $(pdf).height((clientHeight - navbarHeight) + 'px');
        },
        _loadResult: function (serializable, target) {
            _container.empty();
            _containerRow.hide();

            MDB.DPN.BriggsAndWalker._disableBackButton();

            return $.Deferred(function(def) {
                $.ajax({
                    url: target,
                    method: _formMethod,
                    data: serializable.serialize(),
                    success: function (data) {
                        if (data && data.Success === false) {
                            alert(data.Error);
                            def.reject();
                            return;
                        }

                        var $data = $(data);
                        if ($data.hasClass('embedded-pdf-container')) {
                            MDB.DPN.BriggsAndWalker._scalePdfContainer($data);
                            MDB.DPN.BriggsAndWalker._enableBackButton();
                        }

                        MDB.DPN.BriggsAndWalker._bindViewerLinks($data);

                        _container.html($data);
                        _containerRow.show();
                        
                        def.resolve($data);
                    }
                })
            }).promise();
        },
        _bindViewerLinks: function(selector){
            selector.find('a.view-contract-link').on('click', function (e) {
                e.preventDefault();

                MDB.DPN.BriggsAndWalker._loadResult({ serialize: $.noop }, $(this).prop('href'));
            });
        },
        _setupDatepicker: function(form){
            var startEl = form.find('#Start')
                , endEl = form.find('#End');
            
            form.find('#datepicker').mdbDatepicker({
                dateFormat: 'DD-MM-YYYY',
                parent: '#display-contract-form',
                callback: function(start, end){
                    startEl.val(start);
                    endEl.val(end);
                }
            });
        },
        bootStorage: function () {
            _backButton = $('.btn-back');
            
            var form = $('#display-contract-form')
                , formTarget = form.attr('action')
                , previousResult;
            
            _formMethod = form.attr('method');
            _container = $('#display-contract-result-container');
            _containerRow = $('#display-contract-result-container-row');
            
            _containerRow.hide();

            _backButton.on('click', function(){
                MDB.DPN.BriggsAndWalker._disableBackButton();
                _container.html(previousResult); 
                MDB.DPN.BriggsAndWalker._bindViewerLinks(_container);
            });
            
            MDB.DPN.BriggsAndWalker._setupDatepicker(form);
            
            var formControls = form.find('input,button');
            
            var formSerializeable = {
                serialize: function() {
                    var serializedForm = form.serialize();
                    formControls.attr('disabled', 'disabled');
                    return serializedForm;
                }
            };

            form.on('submit', function (e) {
                e.preventDefault();

                MDB.alert(undefined,'Resultaten laden',{
                    'show.bs.modal': function () {
                        $(this).find('.modal-body').append($('<div />', { 'class': 'loading' }));
                    }
                });
                
                MDB.DPN.BriggsAndWalker._loadResult(formSerializeable, formTarget)
                    .always(function($data) {
                        previousResult = $data;
                        
                        formControls.attr('disabled', null);
                        MDB.killOpenModals();
                    });
            });
        }
    });
}());